import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamation } from '@fortawesome/free-solid-svg-icons';

export default function FormIcon({
  icon,
  error,
  validated = false,
  className,
}) {
  return (
    <div
      className={`absolute top-4 right-4 flex h-[30px] w-[30px] items-center justify-center p-1 text-crio-neutral-200 ${
        validated
          ? 'bg-crio-neutral-500'
          : error
          ? 'bg-v5-red-200'
          : 'bg-[#525252]'
      } rounded-2xl ${className ? className : ''}`}
    >
      {validated ? (
        <FontAwesomeIcon icon="fa-solid fa-check" />
      ) : error ? (
        <FontAwesomeIcon
          icon={faExclamation}
          style={{ color: 'crio-neutral-200' }}
        />
      ) : (
        icon
      )}
    </div>
  );
}
